import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Define global functions for modal interactions early
declare global {
  interface Window {
    togglePassword: (passwordId: string, password: string, button: HTMLElement) => void;
    copyToClipboard: (text: string, button: HTMLElement) => void;
  }
}

window.togglePassword = function(passwordId: string, password: string, button: HTMLElement) {
  console.log('togglePassword called', passwordId);
  const elem = document.getElementById(passwordId);
  if (elem) {
    if (elem.textContent === '••••••••') {
      elem.textContent = password;
      button.innerHTML = '🙈 Hide';
    } else {
      elem.textContent = '••••••••';
      button.innerHTML = '👁️ Show';
    }
  }
};

window.copyToClipboard = function(text: string, button: HTMLElement) {
  console.log('copyToClipboard called', text);
  navigator.clipboard.writeText(text).then(() => {
    const feedback = button.nextElementSibling as HTMLElement;
    if (feedback) {
      feedback.style.opacity = '1';
      setTimeout(() => {
        feedback.style.opacity = '0';
      }, 2000);
    }
  }).catch(() => {
    // Fallback for older browsers
    const textArea = document.createElement('textarea');
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand('copy');
    document.body.removeChild(textArea);
    
    const feedback = button.nextElementSibling as HTMLElement;
    if (feedback) {
      feedback.style.opacity = '1';
      setTimeout(() => {
        feedback.style.opacity = '0';
      }, 2000);
    }
  });
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);